import { ListViewChildProps } from '@app/core/list-view/ListView';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { YoutubeBroadcast, YoutubeBroadcastVideo } from '../../youtube-broadcast-types';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { YoutubeBroadcastCard } from '../card/YoutubeBroadcastCard';
import { YoutubeBroadcastsGridSkeleton } from './YoutubeBroadcastsGridSkeleton';
import {
  YOUTUBE_BROADCASTS_GRID_ITEM_SIZE,
  YOUTUBE_BROADCASTS_GRID_SPACING,
} from './youtube-broadcasts-grid-constants';

export type YoutubeBroadcastsGridViewProps = ListViewChildProps<YoutubeBroadcast>;

/**
 * Renders YouTube broadcasts as a responsive grid of cards for the selected day.
 */
export function YoutubeBroadcastsGridView({
  data,
  isLoading = false,
}: YoutubeBroadcastsGridViewProps) {
  const station = useActiveStation();

  if (isLoading) {
    return <YoutubeBroadcastsGridSkeleton />;
  }

  return (
    <Box>
      <Grid container spacing={YOUTUBE_BROADCASTS_GRID_SPACING} columns={60}>
        {data.map((broadcast) => (
          <Grid
            size={YOUTUBE_BROADCASTS_GRID_ITEM_SIZE}
            key={`${broadcast.streamStartedAt}-${broadcast.streamEndedAt}`}
          >
            <YoutubeBroadcastCard broadcast={broadcast} stationSlug={station.slug} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
